import { render, staticRenderFns } from "./AiDisclaimer.vue?vue&type=template&id=16599e74&scoped=true"
import script from "./AiDisclaimer.vue?vue&type=script&lang=js"
export * from "./AiDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./AiDisclaimer.vue?vue&type=style&index=0&id=16599e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16599e74",
  null
  
)

export default component.exports